import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// import * as rolesActions from "store/entities/settingsInfo/action";
import * as settingsActions from "store/entities/settingsInfo/action";

import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ButtonLoader, Input, SelectInput } from "components/__new/common/form";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import Pagination from "components/__new/common/pagination";
import DropdownNew from "utils/dropdown";
import { colorPalette } from 'data/colorPalette';
import { roleColorPalette } from 'data/colorPalette';
import { nameInitials } from 'utils/nameInitials';
import iconPlus from "assets/images/icons/project-icons/Plus.svg";
import FormDrawer from "components/__new/common/form-drawer";
import ModalAlert from "components/__new/common/ModalAlert";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import useMultiSelect from "hooks/useMultiSelect";
import TeamsFilterModal from "components/__new/common/form/TeamsFilterModal";
import ViewTeamMemberModal from "components/__new/common/form/ViewTeamMemberModal";
import DeactivateUserModal from "components/__new/common/form/DeactivateUserModal";
import UserPasswordResetModal from "components/__new/common/form/UserPasswordReset"
import { InviteNewMemberModal, EditNewMemberModal, TransferOwnershipModal } from "components/__new/teams/modal";
import {renderRoleColor, renderStatusColor} from "utils/statusColor"
import { TableContent } from "components/__new/common/TableContent";
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import useLoginInfo from "hooks/useLoginInfo";
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { toast } from "react-toastify";
import ContentLoading from "components/__new/common/ContentLoading";
import pluralize from "utils/pluralize";








const List = () => {
    const dispatch = useDispatch()
    const {userInfo} = useLoginInfo()
    const {employerId} = userInfo?.company
    const location = useLocation()
    const { getMembersLoading, getMembers } = useSelector((s) => s.entities.settingsInfo);
    const {urlQueryParams} = useUrlQueryParams();
    
    
    // const [listParams, setListParams] = useState({page: 1, limit: 20})
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    const [isOpenCreateAdmin, setIsOpenCreateAdmin] = useState(false);
    const [isOpenChangeRole, setIsOpenChangeRole] = useState(false);
    const { InlineRouterTab } = useInlinePageRouter();
    const { toggleMultiSelectHeader } = useMultiSelect();
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [openInviteNewMember, setOpenInviteNewMember] = useState(false);
    const [openViewTeamModal, setOpenViewTeamModal] = useState(false);
    const [openEditNewMember, setOpenEditNewMember] = useState(false);
    const [openTransferOwnership, setOpenTransferOwnership] = useState(false);
   
    const [openDeactivateUserModal, setOpenDeactivateUserModal] = useState(false);
    const [openUserPassReset, setOpenUserPassReset] = useState(false);
    const [viewMember, setViewMember]=useState({})
    
    const toggleFilterModal = () => setIsFilterModalOpen(!isFilterModalOpen);
    
    const toggleViewTeamModal = (teamMember) => {
        setViewMember(({...teamMember}))
        setOpenViewTeamModal(!openViewTeamModal)
    };
    
    const toggleEditTeamModal = (teamMember) => {
        setViewMember(({...teamMember}))
        setOpenEditNewMember(!openViewTeamModal)
    };
    
    const toggleTransferOwnership = () => {
        setOpenTransferOwnership(!openTransferOwnership)
    };
    
    const handleResendInvite = (member) =>{
        dispatch(settingsActions.resendMemberInvite(member?.email));
        toast.success("An invitation request has been sent")
    }
    
    
    const toggleUserPasswordModal = (teamMember) => {
        setViewMember(({...teamMember}))
        setOpenUserPassReset(prev => !prev);
    }
    
    const toggleDeactivateUserModal = (teamMember) => {
        setViewMember(({...teamMember}))
        setOpenDeactivateUserModal(!openDeactivateUserModal)
    }
    
    const queryOptions = [
        {
            title: "Profile Information",
            path: "/settings/profile"
            
        },
        {
            title: "Company Details",
            path: "/settings/info"           
        },
        {
            title: "Teams",
            path: "/settings/team-management",
            
        },
        {
            title: "Role Management",
            path: "/settings/team-management/roles",
            
        },
        {
            title: "On-Demand Pay",
            path: "/settings/ondemand-pay",
            
        },
        {
            title: "Login & Security",
            path: "/settings/login-security",
           
        },
        // {
        //     title: "Notifications",
        //     path: "/settings/notifications",
           
        // },
    ]
    
    const getAllRoles = () => { 
        let params = {...listParams, employerId};

        // params = processParams(urlQueryParams, params, "role", "string", "", "role");
        // params = processParams(urlQueryParams, params, "status", "string", "", "status");
        
        setListParams(params);
        dispatch(settingsActions.getAllRoles(params));
     }
    
    
    const getAllTeamMembers = () => {
        let params = {...listParams};

        // params = processParams(urlQueryParams, params, "role", "string", "", "role");
        // params = processParams(urlQueryParams, params, "status", "string", "", "status");ing", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        // console.log(params)
        
        setListParams(params);
        dispatch(settingsActions.getAllMembers(params));
        // dispatch(settingsActions.getMembers());
    }
    // useCallback(getAllTeamMembers, [setListParams] )
    
    // eslint-disable-next-line
    
    useEffect(() => {
        getAllTeamMembers()
    }, [location]);
        // console.log(getMembers)
    
    const numberOfMembers = getMembers?.data?.totalDocs ?? 0
    const colorKeys = Object.keys(colorPalette);
    const colorObjectKeys = Object.keys(colorPalette);
    
    
    return ( 
        <div>
            <DynamicHeadTag
                headerText="Team Management | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />
            
            <InviteNewMemberModal
                    isOpen={openInviteNewMember}
                    setIsOpen={setOpenInviteNewMember}
                    getAllTeamMembers={getAllTeamMembers}
                    getAllRoles={getAllRoles}
            />

            <CreateAdmin
                isOpen={isOpenCreateAdmin}
                setIsOpen={setIsOpenCreateAdmin}
            />


            <ChangeRole
                isOpen={isOpenChangeRole}
                setIsOpen={setIsOpenChangeRole}
            />

            <TeamsFilterModal 
                isOpen={isFilterModalOpen}
                setIsOpen={setIsFilterModalOpen}
                listParams={listParams}
                setListParams={setListParams}
            />
            
            <ViewTeamMemberModal 
                isOpen={openViewTeamModal}
                setIsOpen={setOpenViewTeamModal}
                data={viewMember}
            />
                        
            <EditNewMemberModal
                    isOpen={openEditNewMember}
                    setIsOpen={setOpenEditNewMember}
                    data={viewMember}
                    getAllRoles={getAllRoles}
                    getAllTeamMembers={getAllTeamMembers}
            />
            
            <TransferOwnershipModal 
                isOpen={openTransferOwnership}
                setIsOpen={setOpenTransferOwnership}
                data={getMembers?.data?.data}
            />
            
            <DeactivateUserModal 
                isOpen={openDeactivateUserModal}
                setIsOpen={setOpenDeactivateUserModal}
                getAllTeamMembers={getAllTeamMembers}
                data={viewMember}
            />
            
            <UserPasswordResetModal 
                isOpen={openUserPassReset}
                setIsOpen={setOpenUserPassReset}
                data={viewMember}
            />

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title text-ep-deep-dark">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 w-full">
                <InlineRouterTab
                    items={queryOptions}
                />
            </div>

            <div className="mt-6 p-4 sm:p-6 bg-white" style={{borderRadius: '12px'}}>
                {/* <div className="xl:flex">
                    <div className="w-full xl:w-1/2 flex">
                            <div className="page-title flex pr-2">
                                Teams
                            </div>
                            {
                            getMembersLoading === false && <div className="p-1 px-2 border border-none rounded-3xl bg-ep-primary-100 text-ep-primary-600 font-medium">
                                {getMembersLoading === false && (numberOfMembers > 1 ? (numberOfMembers + ' team members') : (numberOfMembers + ' team member'))}
                            </div>
                            }
                    </div>
                    
                </div> */}
                <div className="flex items-center justify-start w-max">
                    <h3 style={{ fontSize: '18px', lineHeight: '28px' }} className="font-bold leading-7 text-lg text-ep-black pr-2">Teams</h3>
                    <p className="font-medium label h-6 text-sm text-ep-primary-600 " style={{background: '#00535C14'}}>
                        <ContentLoading
                            loading={getMembersLoading}
                            data={<>{numberOfMembers ?? (" " || "-")} {pluralize(numberOfMembers, "team member", "team members")}</>}
                        />
                    </p>
                </div>


                <div className="mt-6">
                    <div className="flex flex-wrap justify-between">
                        <div className="max-w-sm flex-grow sm:mr-6">
                            <SearchBox placeholder="Search Team Member" name="search" extraUrlParams="page=1" />
                        </div>
                        <div className="flex flex-wrap space-x-3 sm:space-x-6">
                            <div onClick={toggleFilterModal} className="btn border">Filter</div>
                            <button onClick={() => setOpenInviteNewMember(prev => !prev)} className="text-white btn btn-ep-primary">
                            <img src={iconPlus} alt="iconPlus" className="w-3 h-3 mr-2 inline" />
                            <span style={{fontWeight: 500, fontSize: '14px', lineHeight: '20px'}}>Invite New Members</span>
                            </button>
                        </div>
                    </div>

                    
                    <div className="mt-6">
                        <div>
                            
                            <div className="mb-4 text-xl hidden print:block">
                                Team Accounts
                            </div>

                            <Table>
                                <Table.Head>
                                    <th>
                                        <div className="flex">
                                            <div className="pr-2">
                                                <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header pr-3" onChange={toggleMultiSelectHeader} />
                                            </div>
                                            <div style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">
                                                Team Member
                                            </div>
                                        </div>
                                    </th>
                                    <th style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">Email Address</th>
                                    <th style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">Role</th>
                                    <th style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">Status</th>
                                    <th></th>
                                    <th></th>
                                </Table.Head>
                                <Table.Body>
                                <TableContent
                                    loading={getMembersLoading}
                                    loadingText="Loading teams list"
                                    data={getMembers?.data?.data}
                                    colspan={6}
                                    emptyUI={<>
                                        <div className="py-20 mx-auto text-center text-base">
                                            <div className="flex justify-center">
                                                <img src={IconEmptyBox} alt="Empty" className="h-48" />
                                            </div>
                                            <div className="text-[#101828] font-medium">
                                                No Data Available Yet
                                            </div>
                                            <div className="mt-1 text-[#4A5564]">
                                                Once available, it will appear here
                                            </div>
                                        </div>
                                    </>}
                                />
                                    {
                                        getMembersLoading === false && getMembers?.data?.data?.map((member, idx) => {
                                            const color = colorKeys[idx % colorKeys.length]; 
                                            
                                            return(
                                            <tr key={member?.id}>
                                                <td>
                                                    <div className="flex items-center">
                                                        <div className="">
                                                            <div>
                                                                <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header pr-3" onChange={toggleMultiSelectHeader} />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className="flex items-center ml-3">
                                                                {member?.profileImage ?
                                                                    <div className='w-10 h-10 mr-3 flex items-center justify-center rounded-full text-white' style={{backgroundColor: colorPalette[color]}}>
                                                                        <img 
                                                                        src={member?.profileImage} 
                                                                        alt="user avatar" 
                                                                        style={{
                                                                            borderRadius: '50%',
                                                                            width: '40px',
                                                                            height: '40px',
                                                                            objectFit: 'cover',
                                                                        }}
                                                                    />
                                                                    </div> :
                                                                    <div className='w-10 h-10 mr-3 flex items-center justify-center rounded-full text-white' style={{backgroundColor: colorPalette[color]}}>
                                                                        <div>{nameInitials(member?.firstName, member?.lastName)}</div>
                                                                    </div> 
                                                                }
                                                                <div className="font-medium tracking-[1%] text-ep-black">
                                                                    <span className="capitalize">{member?.firstName}</span> 
                                                                    <span>&nbsp;</span>
                                                                    <span className="capitalize">{member?.lastName}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{member?.email}</td>
                                                <td>
                                                    <div className={"label font-medium " + renderRoleColor(member?.role?.name?.toLowerCase())}
                                                     style={{backgroundColor: roleColorPalette[color].background, color: roleColorPalette[color].text, }}>
                                                        {member?.role?.name}
                                                    </div>                                            
                                                </td>
                                                <td>
                                                    <div className={`label ${renderStatusColor(member?.status)} capitalize font-bold`}>
                                                        {member?.status === 'active' ? 'active' : member?.status === 'pending' ? 'pending' : 'inactive'}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {<DropdownNew flipSwitch={true}>
                                                            <></>
                                                            <div>
                                                                <div className="dropdown-item dropdown-item-icon flex" style={{"flexWrap": "nowrap"}}>
                                                                    <button type="button" onClick={() => toggleViewTeamModal(member)} className="text-left flex-wrap flex-grow" style={{whiteSpace: "normal"}}>
                                                                        View Member
                                                                    </button>
                                                                </div>
                                                                {
                                                                   member?.role?.name.toLowerCase() !== 'owner' && (
                                                                        <button 
                                                                            type="button" 
                                                                            onClick={() => {
                                                                                toggleEditTeamModal(member)
                                                                            }} 
                                                                            className="dropdown-item dropdown-item-icon text-left"
                                                                        >
                                                                            Edit Team Member
                                                                        </button>     
                                                                    )
                                                                }
                                                                {member?.role?.name.toLowerCase() === 'owner' ?
                                                                    <button type="button" onClick={toggleTransferOwnership} className="dropdown-item dropdown-item-icon text-left">
                                                                        Transfer Ownership
                                                                    </button> :
                                                                    (
                                                                        <>
                                                                            {member?.status === "pending" && <button type="button" onClick={() => handleResendInvite(member)} className="dropdown-item dropdown-item-icon text-left">
                                                                                Resend Invite
                                                                            </button>}
                                                                            <button type="button" onClick={() => toggleUserPasswordModal(member)} className="dropdown-item dropdown-item-icon text-left">
                                                                                Reset Password
                                                                            </button>
                                                                            <button type="button" onClick={() => toggleDeactivateUserModal(member)} className="dropdown-item dropdown-item-icon text-ep-red-500 text-left">
                                                                                Deactivate
                                                                            </button>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        </DropdownNew>}
                                                    </div>
                                                </td>
                                            </tr>
                                            )
                                        }
                                    )
                                    }
                                    

                                </Table.Body>
                            </Table>

                            {/* <Maybe condition={auditTrailLoading === false && auditTrail?.data?.docs?.length > 0}> */}
                                <div className="mt-6">
                                    <Pagination data={getMembers?.data} />
                                </div>
                            {/* </Maybe> */}

                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}


const CreateAdmin = (props) => {
    const {isOpen, setIsOpen} = props;
    const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
    const [form, setForm] = useState({
        email: "",
        name: "",
        role: "",
    });



    const submitForm = (e) => {
        e.preventDefault();
        setIsOpen(false);
        setIsOpenModalAlert(true);
    }

    
    return (
        <>
            <ModalAlert
                successText="Invite sent successfully!"
                dismissText="Close"
                isOpenModalAlert={isOpenModalAlert}
                setIsOpenModalAlert={setIsOpenModalAlert}
            />

        
            <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
                <form onSubmit={submitForm} className="p-8">
                    <div className="font-dm-sans font-bold text-[#0D0C2B] text-lg sm:text-xl">
                        Invite Administrator
                    </div>
                    <div className="mt-1 text-[#121619}">
                        Add a new administrator and assign a role
                    </div>

                    <div className="mt-8">
                        <Input type="email" label="Email address" placeholder="Input email address " value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} />

                        <Input type="text" label="Full name" placeholder="Input Full name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />

                        <SelectInput label="Choose Role" value={form.role} onChange={(e) => setForm(e.target.value)}>
                            <option value="">Select user role</option>
                            <option value="">Role 1</option>
                            <option value="">Role 2</option>
                            <option value="">Role 3</option>
                        </SelectInput>

                        <div className="mt-12 flex space-x-3 justify-start">
                            <ButtonLoader type="submit" loading={false} className="btn btn-ep-primary">
                                Send Invite
                            </ButtonLoader>
                            <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary">
                                Cancel
                            </button>
                        </div>
                    </div>
                    
                </form>
            </FormDrawer>
        </>
    )
}


const ChangeRole = (props) => {
    const {isOpen, setIsOpen} = props;
    const [form, setForm] = useState({
        role: "",
    });



    const submitForm = (e) => {
        e.preventDefault();
        setIsOpen(false);
    }

    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-8">
                <div className="font-dm-sans font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    Edit User Role
                </div>
                <div className="mt-6 text-[#344054}">
                    You are about to make an update on the account for&nbsp;
                    <span className="text-ep-primary font-medium">Chioma Oladele</span>...
                    <div className="mt-3">
                        Select a role to configure access rights for this account
                    </div>
                </div>

                <div className="mt-8">

                    <SelectInput label="Choose Role" value={form.role} onChange={(e) => setForm(e.target.value)}>
                        <option value="">Payroll Administrator</option>
                        <option value="">Role 1</option>
                        <option value="">Role 2</option>
                        <option value="">Role 3</option>
                    </SelectInput>

                    <div className="mt-12 flex space-x-3 justify-start">
                        <ButtonLoader type="submit" loading={false} className="btn btn-ep-primary">
                            Save
                        </ButtonLoader>
                        <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary">
                            Cancel
                        </button>
                    </div>
                </div>
                
            </form>
        </FormDrawer>
    )
}


export default List;